function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';

import RXInlineFormGroup from './RXInlineFormGroup';

var logdown = require('logdown');
var console = logdown('rx-forms-rx-input-list', { prefixColor: '#aa00ff' });

export var RXInputList = function (_React$Component) {
    _inherits(RXInputList, _React$Component);

    function RXInputList(props) {
        _classCallCheck(this, RXInputList);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.componentDidMount = function () {

            var startingElements = _this.props.formData && _this.props.formData[_this.props.group.name] ? _this.props.formData[_this.props.group.name] : _this.props.group.startingElement;
            _this.setState({ groups: _this.getInlineGroups(startingElements) });
        };

        _this.componentDidUpdate = function (prevProps) {

            if (prevProps.formData != _this.props.formData) {
                console.log('update formData for ', _this.props.group, ' with values: ', _this.props.formData);
                _this.setState({ formData: _this.props.formData });
            }
        };

        _this.onChange = function (value) {
            _this.props.parentOnChange(event);
        };

        _this.getInlineGroups = function (numberOfGroups) {
            var groups = [];
            for (var i = 0; i < numberOfGroups; i++) {
                groups.push(React.createElement(RXInlineFormGroup, { key: '' + i, prefix: _this.props.group.name + '_' + i + '_', group: _this.props.group.fields, parentOnChange: _this.props.parentOnChange, formvalidators: _this.state.validators, formData: _this.state.formData, formstore: _this.props.formstore, transformers: _this.props.transformers }));
            }
            return groups;
        };

        _this.onClickAddItem = function () {

            console.log('in OnClickAddItem');

            var groups = _this.state.groups;
            var key = _this.state.groups.length;
            groups.push(React.createElement(RXInlineFormGroup, { key: '' + key, prefix: _this.props.group.name + '_' + key + '_', group: _this.props.group.fields, parentOnChange: _this.props.parentOnChange, formvalidators: _this.state.validators, formstore: _this.props.formstore, transformers: _this.props.transformers }));
            console.log(groups);
            _this.setState({ groups: groups });
            console.log('after setState');
        };

        _this.render = function () {
            var _ref;

            return React.createElement(
                'div',
                { style: (_ref = {
                        display: "block",
                        border: '1px solid green',
                        borderRadius: 4,
                        borderWidth: 0,
                        borderColor: '#d6d7da', width: '100%' }, _ref['borderColor'] = 'black', _ref.minHeight = 80, _ref) },
                React.createElement(
                    'div',
                    { className: 'mt-2', style: { borderStyle: 'solid', borderWidth: 0, borderBottomWidth: 0.5, textAlign: "left", borderColor: '#0069d9', color: '#0069d9', height: 36, width: '100%' } },
                    React.createElement(
                        'span',
                        { className: 'float-left', style: { textAlign: "center" } },
                        _this.props.group.title
                    ),
                    _this.props.group.showAdd && React.createElement('span', { className: 'float-right icon-plus icons font-2xl d-block', style: { fontSize: 24 }, onClick: _this.onClickAddItem })
                ),
                _this.state.groups.map(function (value, index) {
                    return React.createElement(RXInlineFormGroup, { key: '' + index, prefix: _this.props.group.name + '_' + index + '_', group: _this.props.group.fields, parentOnChange: _this.props.parentOnChange, formvalidators: _this.state.validators, formData: _this.state.formData, formstore: _this.props.formstore, transformers: _this.props.transformers });
                })
            );
        };

        _this.state = {
            validators: {},
            groups: [],
            formData: _this.props.formData

        };
        return _this;
    }

    return RXInputList;
}(React.Component);

RXInputList.defaultProps = {};